const processQuestion = (question: string) => {
  // Remove the @[...](...)  format and keep only the content inside square brackets, wrapped in quotes
  return question.replace(/@\[(.*?)\]\(.*?\)/g, '"$1"');
};

export { processQuestion };
